import { apiFetch } from "./apiFetch";

export function fetchDashboard() {
  return apiFetch("/dashboard/");
}